import ReCAPTCHA from 'react-google-recaptcha';
import env from '@/env';
import { forwardRef } from 'react';
import { message } from 'antd';

const Recaptcha = forwardRef<ReCAPTCHA>((_props, ref) => {
    return (
        <ReCAPTCHA
            sitekey={env.RECAPTCHA_SITE_KEY}
            size="invisible"
            ref={ref}
            onErrored={() =>
                message.error(
                    'Falha na execução do reCAPTCHA. Verifique sua conexão.',
                )
            }
        />
    );
});

export default Recaptcha;
